const characters = ["=", "+", "-", "@", "\t", "\r"];
const seperators = [",", ";", "'", '"'];

export const editorCheck = (newString) => {
  newString = newString.replace(/\s+/g, "");
  let isASecurityRisk = false;
  characters.forEach((character) => {
    seperators.forEach((seperator) => {
      if (newString.includes(seperator + character)) isASecurityRisk = true;
    });
  });
  return isASecurityRisk;
};

export const fullCheck = (newString) => {
  newString = newString.replace(/\s+/g, "");
  let isASecurityRisk = false;
  characters.forEach((character) => {
    if (newString.startsWith(character)) isASecurityRisk = true;
    seperators.forEach((seperator) => {
      if (newString.includes(seperator + character)) isASecurityRisk = true;
    });
  });
  return isASecurityRisk;
};
